import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import '../../styles/TechnicianPage.css'; // Ensure this file contains styles for the layout
import axios from '../../axiosConfig';
import calculateDistance from '../../services/distance'; // 导入 calculateDistance 函数
import imgPrefix from '../../imgConfig'; // 导入 imgConfig.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

const TechnicianPage = () => {
  const { t, i18n } = useTranslation();
  const { technicianId } = useParams();
  
  const location = useLocation(); // 获取路由跳转时传递的 state 数据
  const navigate = useNavigate();

  const [technician, setTechnician] = useState(null);
  const [service, setService] = useState(location.state?.service || null); // 用户选择的 ServiceItem 信息
  // const [service, setService] = useState(location.state?.service || (technicianProjects.length > 0 ? technicianProjects[0] : null));

  const [userLocation, setUserLocation] = useState(null); // 用户位置
  const [technicianProjects, setTechnicianProjects] = useState([]); // New state for technician's projects
  // const { calculatedPrice } = location.state || {};
  const [serviceDuration, setServiceDuration] = useState(location.state?.serviceDuration || "60"); // New state for selected duration
  const [calculatedPrice, setCalculatedPrice] = useState(location.state?.calculatedPrice || null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [userData, setUserData] = useState(null);
  const [services, setServices] = useState([]); // 添加服务项目状态

  console.log("technican location",location);
  

  // // 计算两个地理坐标之间的距离（Haversine 公式）
  // const calculateDistance = (lat1, lon1, lat2, lon2) => {
  //   const R = 6371; // 地球半径（公里）
  //   const dLat = (lat2 - lat1) * (Math.PI / 180);
  //   const dLon = (lon2 - lon1) * (Math.PI / 180);
  //   const a =
  //     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //     Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
  //     Math.sin(dLon / 2) * Math.sin(dLon / 2);
  //   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //   const distance = R * c; // 返回距离（公里）
  //   return distance;
  // };

  // 获取用户信息
  useEffect(() => {
    // 从localStorage获取用户信息
    let storedUser = localStorage.getItem('userData');
    
    // 如果userData不存在，尝试使用user键
    if (!storedUser) {
      storedUser = localStorage.getItem('user');
    }
    
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUserData(parsedUser);
        
        // 如果用户已登录，检查该技师是否已经被收藏
        if (parsedUser.id && technician) {
          checkIfFavorited(parsedUser.id, 'coach', technician.id);
        }
      } catch (err) {
        console.error('Error parsing user data', err);
      }
    }
  }, [technician]);

  // 检查技师是否已被收藏
  const checkIfFavorited = async (userId, type, objectId) => {
    try {
      const response = await axios.get(`/favorite/check?userId=${userId}&type=${type}&objectId=${objectId}`);
      if (response.data.code === 0) {
        setIsFavorite(response.data.data);
      }
    } catch (error) {
      console.error('检查收藏状态失败:', error);
    }
  };

  // 切换收藏状态
  const toggleFavorite = async () => {
    if (!userData) {
      toast.error(t('payment.pleaseLoginFirst'));
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    try {
      if (isFavorite) {
        // 取消收藏
        const response = await axios.delete(`/favorite/delete?userId=${userData.id}&type=coach&objectId=${technician.id}`);
        if (response.data.code === 0) {
          setIsFavorite(false);
          toast.success(t('table.delete'));
        } else {
          toast.error(response.data.msg || t('common.operationFailed'));
        }
      } else {
        // 添加收藏
        const favoriteData = {
          userId: userData.id,
          type: 'coach',
          objectId: technician.id,
          objectName: technician.jiaolianbianhao,
          objectImage: technician.jiaoliantupian
        };
        
        const response = await axios.post('/favorite/add', favoriteData);
        if (response.data.code === 0) {
          setIsFavorite(true);
          toast.success(t('table.add'));
        } else {
          toast.error(response.data.msg || t('common.operationFailed'));
        }
      }
    } catch (error) {
      console.error('收藏操作失败:', error);
      toast.error(t('common.operationFailed'));
    }
  };

  // 获取用户位置
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error('Error getting user location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
    // fetch('https://ipinfo.io/json?token=75add37fbc9caf')
    // .then(response => response.json())
    // .then(data => {
    //     const { loc, city, country } = data;
    //     const [latitude, longitude] = loc.split(',');
    //     console.log(`Location: ${city}, ${country} (Lat: ${latitude}, Lon: ${longitude})`);
    //     console.log(data);

    // });
  }, []);

  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    // Fetch technician details
    axios.get(`/jiaolianxinxi/${technicianId}/detail?lang=${currentLang}`)
      .then((response) => {
        console.log("Technician Details:", response);
        console.log("service Details:", service);

        if (response.data.code === 0 && response.data.data[0]) {
          // setTechnician(response.data.data[0]); // Assuming API returns an array or object
          const technicianDetails = response.data.data[0]; // Assuming API returns an array or object
          // 假设所有技师的位置是固定的
          const technicianLat = 39.9042; // 技师的纬度
          const technicianLng = 116.4074; // 技师的经度
          const distance = userLocation
            ? calculateDistance(
                userLocation.latitude,
                userLocation.longitude,
                technicianLat,
                technicianLng
              ).toFixed(2)
            : '未知';
          technicianDetails.distance = distance; // 添加距离信息到技师详情
          setTechnician(technicianDetails);
          console.log("technicianDetails",technicianDetails);
          
          // 如果用户已登录，检查技师是否已收藏
          if (userData && userData.id) {
            checkIfFavorited(userData.id, 'coach', technicianDetails.id);
          }
        }
      })
      .catch((error) => console.error('Error fetching technician details:', error));
  }, [i18n.language]);

  useEffect(() => {
    if (technician&&technician.jiaolianbianhao) {
      const currentLang = i18n.language || 'zh';
      axios.get(`/jiaolian/${technician.jiaolianbianhao}/projects?lang=${currentLang}`)
        .then((response) => {
          console.log('Technician projects:', response);
          setTechnicianProjects(response.data);
          if(service===null){
            setService(response.data[0]);
          }
        })
        .catch((error) => console.error('Error fetching technician projects:', error));
    }
  }, [technician, i18n.language]);

  // 获取服务项目数据
  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    axios.get(`/jianshenxiangmu/autoSort?lang=${currentLang}`)
      .then((response) => {
        if (response.data.code === 0) {
          setServices(response.data.data.list || []);
        }
      })
      .catch((error) => console.error('Error fetching services:', error));
  }, [i18n.language]);

   // 根据服务和时长动态计算价格
   useEffect(() => {
    if (service && service.jiage) {
      let price = service.jiage;
      if (serviceDuration === "90") {
        price *= 1.5;
      } else if (serviceDuration === "120") {
        price *= 2;
      }
      setCalculatedPrice(price);
    }
  }, [service, serviceDuration]);

  // 渲染服务时长
  const renderServiceTime = (service) => {
    if (service.xiangmumingcheng.includes('中式推拿')) {
      return '60' + t('home.duration');
    } else if (service.xiangmumingcheng.includes('SPA')) {
      return service.xiangmumingcheng.includes('泰式') ? '90' + t('home.duration') : '70' + t('home.duration');
    }
    return '70' + t('home.duration');
  };
  
  // 渲染价格
  const renderPrice = (service) => {
    if (service.xiangmumingcheng.includes('中式推拿')) {
      return '168';
    } else if (service.xiangmumingcheng.includes('精油SPA')) {
      return '268';
    } else if (service.xiangmumingcheng.includes('泰式SPA')) {
      return '368';
    }
    return service.jiage || '218';
  };

  // 处理服务项目点击
  const handleServiceClick = (service) => {
    navigate(`/service/${service.id}`);
  };

  // 处理预约点击
  const handleBookingClick = (e, serviceId) => {
    e.stopPropagation();
    navigate(`/appointmentform?serviceId=${serviceId}`);
  };

  const handleReserveClick = () => {
    console.log(service,
      technician,
      // serviceDuration: location.state?.serviceDuration, // 传递服务时长
      serviceDuration, // 传递服务时长
      calculatedPrice,);
    
    if (!service || !technician) {
      alert(t('common.operationFailed'));
      return;
    }

    // 跳转到 BookingPage 并传递服务和技师信息
    navigate(`/booking/${technician.id}`, {
      state: {
        service,
        technician,
        // serviceDuration: location.state?.serviceDuration, // 传递服务时长
        serviceDuration, // 传递服务时长
        calculatedPrice,
      },
    });
  };

  if (!technician) return <div>{t('table.loading')}</div>;

  return (
    <><div className="technician-page">
      <ToastContainer position="top-center" autoClose={2000} />
      
      {/* 后退按钮 */}
      <div className="page-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          {/* <span>返回</span> */}
        </button>
      </div>
      
      {/* Technician Profile */}
      <div className="technician-header">
        <button
          className={`favorite-button ${isFavorite ? 'favorited' : ''}`}
          onClick={toggleFavorite}
        >
          <FontAwesomeIcon icon={isFavorite ? solidHeart : regularHeart} />
          {isFavorite ? t('table.delete') : t('table.add')}
        </button>
      </div>
      <div className="technician-profile">
        <img
          className="technician-image"
          src={`${imgPrefix}/${technician.jiaoliantupian}`}
          alt={technician.jiaolianxingming} />
        <div className="profile-albums">
          <div className="album-item">
            <img
              src={`${imgPrefix}/${technician.jiaoliantupian}`}
              alt="相册1" />
          </div>
          <div className="album-item">
            <img
              src={`${imgPrefix}/${technician.jiaoliantupian}`}
              alt="相册2" />
          </div>
          <div className="album-item play-button">
            <img
              src={`${imgPrefix}/${technician.jiaoliantupian}`}
              alt="视频" />
            <div className="play-overlay">
              <div className="play-icon">▶</div>
            </div>
          </div>
        </div>
        {/* <div className="technician-header">
      <h1>{technician.jiaolianxingming}</h1>
      <button
        className={`favorite-button ${isFavorite ? 'favorited' : ''}`}
        onClick={toggleFavorite}
      >
        <FontAwesomeIcon icon={isFavorite ? solidHeart : regularHeart} />
        {isFavorite ? '已收藏' : '收藏'}
      </button>
    </div> */}
        {/* <p className="technician-distance">{technician.distance}km</p> */}
        {/* <p className="technician-certification">实名认证: {technician.shimingrenzheng ? "已认证" : "未认证"}</p> */}
        {/* <p className="technician-certification">实名认证: 已认证</p> */}
        <button className="reserve-button" onClick={handleReserveClick}>{t('servicesPage.bookNow')}</button>
      </div>

      {/* 技师个人信息卡片 */}
      <div className="technician-profile-card">
        <div className="profile-card-header">
          {/* <div className="profile-avatar">
      <img
        src={`${imgPrefix}/${technician.jiaoliantupian}`}
        alt={technician.jiaolianxingming}
      />
    </div> */}
          <div className="profile-info">
            {/* <h2>{technician.jiaolianxingming}</h2>
    <p className="profile-id">ID {technician.id || '144492'}</p>
    <p className="profile-certification">
      <span className="cert-icon">🏆</span>
      实名认证 {technician.nianling || '27'}岁
    </p>
    <p className="profile-distance">
      <span className="distance-icon">📍</span>
      {technician.distance}km
    </p>
    <div className="profile-appointment">
      <span className="appointment-time">今日可约 17:00</span>
      <span className="appointment-count">527人已关注</span>
    </div> */}
            <div className="profile-info-left">
              <h2>{technician.jiaolianxingming}</h2>
              <p className="profile-id">ID {technician.id || '144492'}</p>
              <p className="profile-certification">
                <span className="cert-icon">🏆</span>
                {t('table.status')} {technician.nianling || '27'}{t('home.duration')}
              </p>
            </div>
            <div className="profile-info-right">
              <p className="profile-distance">
                <span className="distance-icon">📍</span>
                {technician.distance}km
              </p>
              <div className="profile-appointment">
                <span className="appointment-time">17:00</span>
                <span className="appointment-count">527</span>
              </div>
            </div>
          </div>
        </div>

        {/* 相册区域 */}
        {/* <div className="profile-albums">
      <div className="album-item">
        <img
          src={`${imgPrefix}/${technician.jiaoliantupian}`}
          alt="相册1"
        />
      </div>
      <div className="album-item">
        <img
          src={`${imgPrefix}/${technician.jiaoliantupian}`}
          alt="相册2"
        />
      </div>
      <div className="album-item play-button">
        <img
          src={`${imgPrefix}/${technician.jiaoliantupian}`}
          alt="视频"
        />
        <div className="play-overlay">
          <div className="play-icon">▶</div>
        </div>
      </div>
    </div> */}

        {/* 个人信息详情 */}
        <div className="profile-details">
          <div className="detail-row">
            <span className="detail-label">{t('table.details')}</span>
            <span className="detail-value">4.5星</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('userMgmt.gender')}</span>
            <span className="detail-value">{technician.shengao || '178'}cm</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('userMgmt.balance')}</span>
            <span className="detail-value">{technician.tizhong || '80'}kg</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('userMgmt.address')}</span>
            <span className="detail-value">内蒙古</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('table.status')}</span>
            <span className="detail-value">牛</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('table.status')}</span>
            <span className="detail-value">汉族</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('table.createTime')}</span>
            <span className="detail-value">{technician.ruzhushijian ? new Date(technician.ruzhushijian).getFullYear() + '年' : '5年'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('table.details')}</span>
            <span className="detail-value">专科</span>
          </div>
        </div>

        {/* 个人简介 */}
        <div className="profile-description">
          <p></p>
        </div>

        {/* 资质证书 */}
        <div className="profile-certificates">
          <div className="certificate-item">
            <span className="cert-icon">🏆</span>
            <span className="cert-name">{t('table.details')}</span>
          </div>
          <div className="certificate-item">
            <span className="cert-icon">🏆</span>
            <span className="cert-name">{t('table.details')}</span>
          </div>
          <div className="certificate-item">
            <span className="cert-icon">🏆</span>
            <span className="cert-name">{t('table.details')}</span>
          </div>
          <div className="certificate-item">
            <span className="cert-icon">🏆</span>
            <span className="cert-name">{t('table.details')}</span>
          </div>
        </div>
      </div>

      {/* Attributes Section */}
      {/* <div className="technician-attributes">
      <h1>技师信息</h1>
      <ul>
        <li>性别: {technician.xingbie}</li>
        <li>年龄: {technician.nianling}</li>
        <li>身高: {technician.shengao} cm</li>
        <li>体重: {technician.tizhong} kg</li>
        <li>入驻时间: {technician.ruzhushijian}</li>
        <li>电话: {technician.lianxidianhua}</li>
      </ul>
    </div> */}

      {/* Services Offered */}
     
      <div className="service-selection">
        <h2>{t('technicianPage.selectService')}</h2>
        {/* <select
      value={service.xiangmubianhao}
      onChange={(e) => setService(service)}
    >
      <option value={service.xiangmubianhao}>{service.xiangmumingcheng}</option>
    </select> */}
        <select
          value={service?.xiangmumingcheng}
          // onChange={(e) => setService(technicianProjects.find(project => project.xiangmubianhao === e.target.value))}
          onChange={(e) => {
            const selectedService = technicianProjects.find(project => project.xiangmumingcheng === e.target.value);
            setService(selectedService);
          } }
        >
          {technicianProjects.map((project) => (
            <option key={project.xiangmubianhao} value={project.xiangmubianhao}>
              {project.xiangmumingcheng}
            </option>
          ))}
        </select>

      </div>

      <div className="duration-selection">
        <h2>{t('technicianPage.selectDuration')}</h2>
        <label>
          <input
            type="radio"
            value="60"
            checked={serviceDuration === "60"}
            onChange={() => setServiceDuration("60")} />
          60{t('technicianPage.minute')}
        </label>
        <label>
          <input
            type="radio"
            value="90"
            checked={serviceDuration === "90"}
            onChange={() => setServiceDuration("90")} />
          90{t('technicianPage.minute')}
        </label>
        <label>
          <input
            type="radio"
            value="120"
            checked={serviceDuration === "120"}
            onChange={() => setServiceDuration("120")} />
          120{t('technicianPage.minute')}
        </label>
      </div>

      <div className="price-display">
        <h2>{t('technicianPage.price')}: {calculatedPrice}元</h2>
      </div>

       <div className="technician-services">
        <h2>{t('technicianPage.serviceItems')}</h2>

        <div className="service-items-container">
  {technicianProjects.length > 0 && technicianProjects.map((service) => (
    <div key={service.id}
      className="service-item-card"
      onClick={() => handleServiceClick(service)}>

      <div className="service-image-container">
        <img
          src={`${imgPrefix}/${service.xiangmutupian}`}
          alt={service.xiangmumingcheng} />
        <div className="service-time-bubble">
          <span className="time-label">{t('servicesPage.duration')}</span>
          <span className="time-value">{renderServiceTime(service)}</span>
        </div>
        {service.xiangmumingcheng.includes('中式推拿') &&
          <div className="tag-purple">{t('servicesPage.specialOffer')}</div>}
      </div>

      <div className="service-content">
        <div>
          <div className="service-header">
            <div className="tag-premium">{t('servicesPage.premium')}</div>
            <h3 className="service-title">
              {service.xiangmumingcheng}
            </h3>
          </div>

          <div className="service-details">
            <p className="service-duration">{t('servicesPage.duration')}：{renderServiceTime(service)}</p>
            <p className="service-process">{t('servicesPage.processLabel')}：仰/俯卧位(头部、肩颈、腹部、腰背...)</p>
            <p className="fast-arrival">{t('servicesPage.fastArrival')}</p>
          </div>
        </div>

        <div className="service-footer">
          <div className="price-sales">
            <div className="price">{renderPrice(service)}元/次起</div>
            <div className="sales">
              {t('servicesPage.sold')}{service.xiangmumingcheng.includes('中式推拿') ? '5万+' :
                service.xiangmumingcheng.includes('精油SPA') ? '101万+' :
                  service.xiangmumingcheng.includes('泰式SPA') ? '2万+' : '136万+'}
              {t('servicesPage.goodRate')}{Math.floor(Math.random() * 2) + 98}%
            </div>
          </div>
          <button
            className="booking-button"
            onClick={(e) => handleBookingClick(e, service.id)}
          >
            立即预约
          </button>
        </div>
      </div>
    </div>
  ))}
</div>
        {/* <ul>
      {technician.fuwuxiangmu.map((service) => (
        <li key={service.id} className="service-item">
          <img
            src={`${imgPrefix}/${service.tupian}`}
            alt={service.xiangmumingcheng}
          />
          <div>
            <h3>{service.xiangmumingcheng}</h3>
            <p>{service.xiangmujieshao}</p>
            <p className="service-price">价格: {service.jiage} 元/次</p>
            <button className="reserve-button">立即预约</button>
          </div>
        </li>
      ))}
    </ul> */}
        {/* <ul>
          {technicianProjects.map((project) => (
            <li key={project.id}>{project.xiangmumingcheng}</li>
          ))}
        </ul> */}
      </div>

      {/* 服务项目容器 */}


    </div>
    

      </>
  );
};

export default TechnicianPage;
